export const PENDING_SRC = '//:0';
